import { observer } from "mobx-react";
import { Header } from "../../components/Header";
import "./DataPrivacy.scss";

const DataPrivacyPage = () => {
  return (
    <div className="main-container">
      <Header />
      <h3>Verantwortlicher</h3>
      <div className="spacer" />
      <p>
        Sofern in dieser Datenschutzerklärung nicht anders angegeben, ist der
        Verantwortliche für die Erhebung, Bearbeitung und Nutzung Ihrer
        Personendaten: <br /> Pass.me Weite Gasse 13 5400 Baden Schweiz
      </p>
      <div className="spacer" />
      <p>E-Mail: info@pass.me</p>
      <p>
        Website: <a href="https://pass.me">https://pass.me</a>
      </p>
      <div className="spacer" />
      <h3>Allgemeine Zwecke der Bearbeitung</h3>
      <div className="spacer" />
      <p>
        Wir verwenden Personendaten zum Zweck der Bereitstellung
        funktionsfähiger Websites und zur Erbringung unserer Inhalte und
        Leistungen. Pass.me behandelt Personendaten vertrauensvoll, sorgfältig
        und zweckbestimmt. Dabei halten wir uns an die massgeblichen Vorgaben
        des anwendbaren Datenschutzrechts.
      </p>
      <br />
      <br />
      <h3>Arten der erhobenen Daten</h3>
      <br />
      <br />
      <p>
        Pass.me besteht aus zwei Anwendungen - eine für den Endnutzer und eine
        für die Aufsichtspersonen, die die Tests überprüfen.
        <br />
        <br />
        Die Endbenutzer-Anwendung sendet keine Daten über das Netzwerk, außer
        den zufällig generierten IDs, anonymen Test-IDs und dem Foto des Tests.
        Alle persönlichen Daten, die der Endbenutzer eingibt, werden lokal auf
        dem Telefon gespeichert.
        <br />
        <br />
        Die Supervisor-Anwendung erfordert mehr personenbezogenen Daten, um
        sicherzustellen, dass die Aufsichtspersonen das System nicht
        missbrauchen.
        <br />
        <br />
        Die Daten der Aufsichtspersonen werden automatisch gelöscht, wenn sie
        einen Monat lang keine Überprüfungen durchführen.
        <br />
        <br />
        Zu den personenbezogenen Daten, die Pass.me Supervisor verarbeitet,
        gehören: Vorname; Nachname; Geburtsdatum; Telefonnummer; Land;
        Postleitzahl; E-Mail; Name des Unternehmens;. Vollständige Details zu
        jeder Art von verarbeiteten personenbezogenen Daten werden in den dafür
        vorgesehenen Abschnitten dieser Datenschutzerklärung oder punktuell
        durch Erklärungstexte bereitgestellt, die vor der Datenerhebung
        angezeigt werden. Personenbezogene Daten können vom Nutzer freiwillig
        angegeben oder, im Falle von Nutzungsdaten, automatisch erhoben werden,
        wenn diese Anwendung genutzt wird. Sofern nicht anders angegeben, ist
        die Angabe aller durch diese Anwendung angeforderten Daten
        obligatorisch. Weigert sich der Nutzer, die Daten anzugeben, kann dies
        dazu führen, dass diese Anwendung dem Nutzer ihre Dienste nicht zur
        Verfügung stellen kann. In Fällen, in denen diese Anwendung die Angabe
        personenbezogener Daten ausdrücklich als freiwillig bezeichnet, dürfen
        sich die Nutzer dafür entscheiden, diese Daten ohne jegliche Folgen für
        die Verfügbarkeit oder die Funktionsfähigkeit des Dienstes nicht
        anzugeben. Nutzer, die sich darüber im Unklaren sind, welche
        personenbezogenen Daten obligatorisch sind, können sich an den Anbieter
        wenden. Jegliche Verwendung von Cookies – oder anderer Tracking-Tools –
        durch diese Anwendung oder Anbieter von Drittdiensten, die durch diese
        Anwendung eingesetzt werden, dient dem Zweck, den vom Nutzer gewünschten
        Dienst zu erbringen, und allen anderen Zwecken, die im vorliegenden
        Dokument und, falls vorhanden, in der Cookie-Richtlinie beschrieben
        sind. Die Nutzer sind für alle personenbezogenen Daten Dritter
        verantwortlich, die durch diese Anwendung beschafft, veröffentlicht oder
        weitergegeben werden, und bestätigen, dass sie die Zustimmung zur
        Übermittlung personenbezogener Daten etwaiger Dritter an diese Anwendung
        eingeholt haben.
      </p>
      <br />
      <br />
      <h3>Art und Ort der Datenverarbeitung</h3>
      <br />
      <br />
      <h5>Verarbeitungsmethoden</h5>
      <br />
      <br />
      <p>
        Der Anbieter verarbeitet die Nutzerdaten auf ordnungsgemäße Weise und
        ergreift angemessene Sicherheitsmaßnahmen, um den unbefugten Zugriff und
        die unbefugte Weiterleitung, Veränderung oder Vernichtung von Daten zu
        vermeiden. Die Datenverarbeitung wird mittels Computern oder
        IT-basierten Systemen nach organisatorischen Verfahren und
        Verfahrensweisen durchgeführt, die gezielt auf die angegebenen Zwecke
        abstellen. Zusätzlich zum Verantwortlichen könnten auch andere Personen
        intern (Personalverwaltung, Vertrieb, Marketing, Rechtsabteilung,
        Systemadministratoren) oder extern – und in dem Fall soweit
        erforderlich, vom Verantwortlichen als Auftragsverarbeiter benannt (wie
        Anbieter technischer Dienstleistungen, Zustellunternehmen,
        Hosting-Anbieter, IT-Unternehmen oder Kommunikationsagenturen) - diese
        Anwendung betreiben und damit Zugriff auf die Daten haben. Eine aktuelle
        Liste dieser Beteiligten kann jederzeit vom Anbieter verlangt werden.
      </p>
      <br />
      <br />
      <h5>Rechtsgrundlagen der Verarbeitung</h5>
      <br />
      <br />
      <p>
        Der Anbieter darf personenbezogene Daten von Nutzern nur dann
        verarbeiten, wenn einer der folgenden Punkte zutrifft:
      </p>
      <br />
      <br />
      <ul>
        <li>
          <p>
            Die Nutzer haben ihre Einwilligung für einen oder mehrere bestimmte
            Zwecke erteilt. Hinweis: In einigen Gesetzgebungen kann es dem
            Anbieter gestattet sein, personenbezogene Daten zu verarbeiten, bis
            der Nutzer einer solchen Verarbeitung widerspricht („Opt-out“), ohne
            sich auf die Einwilligung oder eine andere der folgenden
            Rechtsgrundlagen verlassen zu müssen. Dies gilt jedoch nicht, wenn
            die Verarbeitung personenbezogener Daten dem europäischen
            Datenschutzrecht unterliegt;
          </p>
        </li>
        <li>
          <p>
            die Datenerhebung ist für die Erfüllung eines Vertrages mit dem
            Nutzer und/oder für vorvertragliche Maßnahmen daraus erforderlich;
          </p>
        </li>
        <li>
          <p>
            die Verarbeitung ist für die Erfüllung einer rechtlichen
            Verpflichtung, der der Anbieter unterliegt, erforderlich;
          </p>
        </li>
        <li>
          <p>
            die Verarbeitung steht im Zusammenhang mit einer Aufgabe, die im
            öffentlichen Interesse oder in Ausübung hoheitlicher Befugnisse, die
            dem Anbieter übertragen wurden, durchgeführt wird;
          </p>
        </li>
        <li>
          <p>
            die Verarbeitung ist zur Wahrung der berechtigten Interessen des
            Anbieters oder eines Dritten erforderlich.
          </p>
        </li>
      </ul>
      <br />
      <br />
      <p>
        In jedem Fall erteilt der Anbieter gerne Auskunft über die konkrete
        Rechtsgrundlage, auf der die Verarbeitung beruht, insbesondere darüber,
        ob die Angabe personenbezogener Daten eine gesetzliche oder vertragliche
        Verpflichtung oder eine Voraussetzung für den Abschluss eines Vertrages
        ist.
      </p>
      <br />
      <br />
      <h4>Ort</h4>
      <br />
      <br />
      <p>
        Die Daten werden in der Niederlassung des Anbieters und an allen anderen
        Orten, an denen sich die an der Datenverarbeitung beteiligten Stellen
        befinden, verarbeitet.
      </p>
      <br />
      <br />
      <p>
        Je nach Standort der Nutzer können Datenübertragungen die Übertragung
        der Daten des Nutzers in ein anderes Land als das eigene beinhalten. Um
        mehr über den Ort der Verarbeitung der übermittelten Daten zu erfahren,
        können die Nutzer den Abschnitt mit den ausführlichen Angaben zur
        Verarbeitung der personenbezogenen Daten konsultieren.
      </p>
      <br />
      <br />
      <p>
        Die Nutzer haben auch das Recht, sich über die Rechtsgrundlage der
        Datenübermittlung in ein Land außerhalb der Europäischen Union oder an
        eine internationale Organisation, die dem Völkerrecht unterliegt oder
        von zwei oder mehr Ländern gegründet wurde, wie beispielsweise die UNO,
        sowie sich über die vom Anbieter ergriffenen Sicherheitsmaßnahmen zum
        Schutz ihrer Daten aufklären zu lassen.
      </p>
      <br />
      <br />
      <p>
        Wenn eine solche Übermittlung stattfindet, kann der Nutzer mehr darüber
        erfahren, indem er die entsprechenden Abschnitte dieses Dokuments
        überprüft oder sich mit dem Anbieter über die im Kontaktteil angegebenen
        Informationen in Verbindung setzt.
      </p>
      <br />
      <br />
      <h4>Speicherdauer</h4>
      <br />
      <br />
      <p>
        Personenbezogene Daten werden so lange verarbeitet und gespeichert, wie
        es der Zweck erfordert, zu dem sie erhoben wurden.
      </p>
      <br />
      <br />
      <p>Daher gilt:</p>
      <br />
      <br />
      <ul>
        <li>
          <p>
            Personenbezogene Daten, die zu Zwecken der Erfüllung eines zwischen
            dem Anbieter und dem Nutzer geschlossenen Vertrages erhoben werden,
            werden bis zur vollständigen Erfüllung dieses Vertrages gespeichert.
          </p>
        </li>
        <li>
          <p>
            Personenbezogene Daten, die zur Wahrung der berechtigten Interessen
            des Anbieters erhoben werden, werden so lange aufbewahrt, wie es zur
            Erfüllung dieser Zwecke erforderlich ist. Nutzer können nähere
            Informationen über die berechtigten Interessen des Anbieters in den
            entsprechenden Abschnitten dieses Dokuments oder durch
            Kontaktaufnahme zum Anbieter erhalten.
          </p>
        </li>
      </ul>
      <br />
      <p>
        Darüber hinaus ist es dem Anbieter gestattet, personenbezogene Daten für
        einen längeren Zeitraum zu speichern, wenn der Nutzer in eine solche
        Verarbeitung eingewilligt hat, solange die Einwilligung nicht widerrufen
        wird. Darüber hinaus kann der Anbieter verpflichtet sein,
        personenbezogene Daten für einen längeren Zeitraum aufzubewahren, wenn
        dies zur Erfüllung einer gesetzlichen Verpflichtung oder auf Anordnung
        einer Behörde erforderlich ist.
      </p>
      <br />
      <br />
      <p>
        Nach Ablauf der Aufbewahrungsfrist werden personenbezogene Daten
        gelöscht. Daher können das Auskunftsrecht, das Recht auf Löschung, das
        Recht auf Berichtigung und das Recht auf Datenübertragbarkeit nach
        Ablauf der Aufbewahrungsfrist nicht geltend gemacht werden.
      </p>
      <br />
      <br />
      <h3>Zwecke der Verarbeitung</h3>
      <br />
      <br />
      <p>
        Personenbezogene Daten über den Nutzer werden erhoben, damit der
        Anbieter den Dienst erbringen und des Weiteren seinen gesetzlichen
        Verpflichtungen nachkommen, auf Durchsetzungsforderungen reagieren,
        seine Rechte und Interessen (oder die der Nutzer oder Dritter) schützen,
        böswillige oder betrügerische Aktivitäten aufdecken kann. Darüber hinaus
        werden Daten zu folgenden Zwecken erhoben: Überwachung der
        Infrastruktur, Kontaktieren des Nutzers, Registrierung und Anmeldung
        unmittelbar über diese Anwendung und Geräteberechtigungen für den
        Zugriff auf personenbezogene Daten.
      </p>
      <br />
      <p>
        Nutzer können im Abschnitt “Ausführliche Angaben über die Verarbeitung
        personenbezogener Daten” dieses Dokuments weitere detaillierte
        Informationen zu diesen Verarbeitungszwecken und die zu den für den
        jeweiligen Zweck verwendeten personenbezogenen Daten vorfinden.
      </p>
      <br />
      <br />
      <h3>Geräteberechtigungen für den Zugriff auf personenbezogene Daten</h3>
      <br />
      <br />
      <p>
        Je nach vom Nutzer benutzten Gerät kann diese Anwendung bestimmte
        Berechtigungen anfragen, die es erlauben, wie unten beschrieben auf die
        Gerätedaten des Nutzers zuzugreifen.
      </p>
      <br />
      <p>
        Standardmäßig müssen diese Zugriffsberechtigungen durch den Nutzer
        erteilt werden, bevor auf die entsprechenden Informationen zugegriffen
        werden kann. Eine einmal erteilte Zustimmung kann jederzeit vom Nutzer
        widerrufen werden. Um diese Zustimmungen zu widerrufen, können Nutzer in
        den Geräteeinstellungen nachsehen oder sie kontaktieren den Support des
        Eigentümers unter den im vorliegenden Dokument genannten Kontaktdaten.
        Die genaue Vorgehensweise für die Überprüfung von App-Berechtigungen
        kann vom Gerät und der Software des Nutzers abhängen. Es ist zu
        beachten, dass diese Anwendung durch den Widerruf solcher Berechtigungen
        in der ordnungsgemäßen Funktion beeinträchtigt sein könnte. Wenn der
        Nutzer eine der unten genannten Berechtigungen erteilt, könnten die
        jeweiligen personenbezogenen Daten durch diese Anwendung verarbeitet
        werden (d.h., es kann darauf zugegriffen, sie können verändert oder
        entfernt werden).
      </p>
      <br />
      <h4>Fotobibliothekberechtigung</h4>
      <br />
      <p>Ermöglicht den Zugriff auf die Fotobibliothek des Nutzers.</p>
      <br />
      <br />
      <h4>Kameraberechtigung</h4>
      <br />
      <p>
        Wird für den Zugriff auf die Kamera oder die Aufnahme von Bildern und
        Videos über das Gerät benötigt.
      </p>
      <br />
      <h4>
        Weitere Informationen über die personenbezogenen Daten des Nutzers
      </h4>
      <br />
      <p>
        Zusätzlich zu den in dieser Datenschutzerklärung aufgeführten
        Informationen kann diese Anwendung dem Nutzer auf Anfrage weitere
        kontextbezogene Informationen zur Verfügung stellen, die sich auf
        bestimmte Dienste oder auf die Erhebung und Verarbeitung
        personenbezogener Daten beziehen.
      </p>
      <br />
      <h4>Systemprotokolle und Wartung</h4>
      <br />
      <p>
        Diese Anwendung und die Dienste von Dritten können zu Betriebs- und
        Wartungszwecken Dateien erfassen, die die über diese Anwendung
        stattfindende Interaktion aufzeichnen (Systemprotokolle), oder andere
        personenbezogene Daten (z. B. IP-Adresse) zu diesem Zweck verwenden.
      </p>
      <br />
      <h4>Nicht in dieser Datenschutzerklärung enthaltene Informationen</h4>
      <br />
      <p>
        Weitere Informationen über die Erhebung oder Verarbeitung
        personenbezogener Daten können jederzeit vom Anbieter über die
        aufgeführten Kontaktangaben angefordert werden.
      </p>

      <br />
      <br />
    </div>
  );
};

export default observer(DataPrivacyPage);
